import * as React from 'react'
import styled from 'styled-components'
import logo from '../images/ostrichLogo.svg'

const Box = styled.div`
  color: #ccc;
  font-family: 'PT Mono';

  a, a:visited {
    color: #ccc;
    text-decoration: none;
    transition: 0.5s all ease;
  }

  a:hover {
    color: #999;
  }
`

const Attr = styled.div`
  font-size: 0.875em;
  margin: 0 16px 16px 0;
  text-align: right;
  color: #888;

  a {
    color: #888;
  }

  a:hover {
    color: #777;
  }
`

const Foot = styled.footer`
  background-color: #26262B;
  box-shadow: 0 -3px 10px rgba(0,0,0,.4);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1em;

  img {
    width: 30px;
    margin-right: 16px;
  }

  p {
    font-size: 1em;
    line-height: 1.5;
  }

  @media (min-width: 415px) {
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
  }
`

const Footer = () => (
  <Box>
    <Attr>Data provided by <a href='http://marvel.com' target='_blank' rel='noopener noreferrer'>Marvel</a>. &copy; 2014 Marvel</Attr>
    <Foot>
      <img src={logo} alt='Ostrich Logo'/>
      <p>Designed &amp; Coded by <a href='http://www.rebeccaostrich.com' target='_blank' rel='noopener noreferrer'>Rebecca&nbsp;Ostrich</a></p>
    </Foot>
  </Box>
)

export default Footer
